import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

//Iconos
import icn_01 from '../../assets/img/landingPage/management/icn_management_01.png';
import icn_02 from '../../assets/img/landingPage/management/icn_management_02.png';
import icn_03 from '../../assets/img/landingPage/management/icn_management_03.png';
import icn_04 from '../../assets/img/landingPage/management/icn_management_04.png';
import icn_05 from '../../assets/img/landingPage/management/icn_management_05.png';

import fondo from '../../assets/img/landingPage/fondo.png';
import ReactGA from 'react-ga4'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

//Importaciones de otros archivos, revisar y borrar
import gradientApi from '../../assets/img/landingPage/gradientApi.png'
import gradientServices from '../../assets/img/landingPage/gradientServices.png'

import product_gateway from '../../assets/img/landingPage/Gateway.png'
import dashboard from '../../assets/img/landingPage/cloud/Cloud-home.png';


const PublicSector = () => {


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-08SZKPG9V0');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: '101OBEX, CORP About Page' });
            }

    }, [])

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);
    
        // clean favicon 
        return () => {
          document.head.removeChild(link);
        };
      }, []);

    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);

    const productDetailsA = {
        Key_Feature_01: {
            title: 'Modernize Legacy Systems Without Disruption',
            text: "Wrap and extend older systems with modern APIs — no need for full replacements or downtime.",
            altDescription: "Key Feature 01",
            image: product_gateway,
        },
        Key_Feature_02: {
            title: "Automate Processes with Gen-AI and Workflows",
            text: "Accelerate operations by orchestrating internal and external systems with intelligent, event-driven automation.",
            altDescription: "Accelerate operations by orchestrating internal and external systems with intelligent, event-driven automation.",
            image: product_gateway,
        },
        Key_Feature_03: {
            title: 'Build Connected Experiences',
            text: 
            "Unify data from multiple channels to deliver seamless user journeys — from web and mobile to partner portals and internal tools.",
            altDescription: 'Unify data from multiple channels to deliver seamless user journeys — from web and mobile to partner portals and internal tools.',
            image: product_gateway,
        },
        Key_Feature_04: {
            title: 'Enable Cross-Department Integration',
            text: 
            "Break down barriers between teams and systems by exposing secure, reusable APIs that serve business and IT.",
            altDescription: 'Break down barriers between teams and systems by exposing secure, reusable APIs that serve business and IT.',
            image: product_gateway,
        },
        Key_Feature_05: {
            title: 'Govern at Scale',
            text: 
            "Apply consistent security, versioning, and monitoring policies across all digital services from a single control plane.",
            altDescription: 'Apply consistent security, versioning, and monitoring policies across all digital services from a single control plane.',
            image: product_gateway,
        },
    }
    
    //Key Benefits Bento
    const items = [
        {
          icon: icn_01,
          title: 'Virtual-first Architecture',
          paragraphs: [
            'Build and test APIs without touching live systems.',
          ],
        
        },
        {
          icon: icn_02,
          title: 'Full API Lifecycle Coverage',
          paragraphs: [
            'Design, simulate, deploy, version, and retire APIs — all in one place.',
          ]
        },

        {
          icon: icn_03,
          title: 'AI-powered Recommendations',
          paragraphs: [
            'Get smart suggestions for scaling, securing, and optimizing services.',
          ]
        },
        {
          icon: icn_04,
          title: 'Total Integration Flexibility',
          paragraphs: [
            'Connect systems via REST, SOAP, event streams, or custom protocols.'
          ]
        },
        {
          icon: icn_05,
          title: 'Comprehensive Governance Tools',
          paragraphs: [
            'Enforce security and quality standards across every API.',
          ]
        },
      ];
      
    const breakpointColumnsObj = {
        default: 3, //Cambio de columnas verticales
        1100: 2,
        700: 1
      
    };

    return (
        <>
            <FlNav></FlNav>
            <div 
            id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}
            >
                {/* Hero Section */}
                <section id="heroProduct" className="text-center py-5">

                    <h1 className="fl-title-big m-0">AVAP for Digital Transformation</h1>
                   
                    <p className="fl-title m-0 gradient-text">Accelerate your transformation. Unlock agility, automation, <br/>and connected experiences.</p>
                                <p className="fl-text fl-txt-container-s" >
                                AVAP Framework empowers organizations to lead digital transformation initiatives with a virtual-first approach, enabling faster innovation, seamless integration, and intelligent automation. Whether you’re upgrading legacy infrastructure or launching new digital products, AVAP gives you the flexibility and control to do it at scale.
                                </p>
                {/*Boton Contact Us*/}  
                    <a className="glowBtn-dark pb-4" style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>
              </section>

        

                {/* Subtítulo descripción */}
                <section className="text-center pb-5">
                    <img
                        src={dashboard}
                        className="img-fluid mt-4"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />
            
                    
                 <div className="fl-card-border container text-center">
                    <h2 className="fl-title pt-8 gradient-text fl-title">Why AVAP for Digital Transformation?</h2>

                    {/*<p className="fl-text fl-txt-container-s">Government agencies and public institutions face complex challenges: legacy infrastructure, siloed systems, growing security needs, and pressure to deliver better citizen services. AVAP Framework empowers you to meet these demands with flexibility and speed.
                    </p><br/>*/}

                    {/* Sección Bullets */}
                    <ul className="fl-bullets fl-text text-center .fl-txt-container-s pb-5">
                    <li className="fl-bullets">Launch digital services faster with low-code, API-first development.</li>
                    <li className="fl-bullets">Reduce costs by reusing components and connecting existing systems.</li>
                    <li className="fl-bullets">Break silos with seamless integration across business units and platforms.</li>
                    <li className="fl-bullets">Gain real-time visibility and insights through API analytics.</li>
                    <li className="fl-bullets">Enable continuous innovation with modular, future-proof architecture.</li> </ul>
                </div>

                   {/* <h2 className="fl-title m-0 gradient-text fl-title m-4">Connect everything. Empower everyone.</h2>
                    <p className="fl-text text-center fl-txt-container-s">
                    AVAP Integration unifies the power of automation, data flow, and intelligent orchestration. With native virtualization and AI assistance, AVAP Framework helps developers and business teams integrate applications, services, and data sources — across clouds, on-premises systems, and legacy architectures — without friction. Free your teams from bottlenecks and legacy dependencies with a platform that adapts to change, scales effortlessly, and delivers real-time integration insights.
                    </p>*/}

                </section>

                {/* Sección Key Features */}
                <div className="fl-wrapper">
                    <img src={gradientServices} className="gradient gradientServices" alt="" />
                    <img src={gradientApi} alt="" className="gradient gradientlife" />
                    <div className="fl-container">
                        <section id="products">
                            {/*   <h3 className="fl-title text-center">Our Products & Services</h3> */}
                            <br />
                            &nbsp;
                            <br />&nbsp;
                            <p className="fl-title-center m-0">Key Capabilities</p>
                            <div className="fl-productsWrapper">
                                {Object.keys(productDetailsA).map((productKey, index) => (
                                    <div key={productKey} className="fl-product-item">
                                        <div className={`row align-items-center ${index % 2 === 0 ? '' : 'flex-row-reverse'}`}>
                                            <div className="col-md-6">
                                                <div className="product-content">
                                                    <h3 className="fl-subtitle">
                                                        {productDetailsA[productKey].title}
                                                    </h3>
                                                    <p className="fl-text">
                                                        {productDetailsA[productKey].text}
                                                    </p>
                                                    
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <img
                                                    src={productDetailsA[productKey].image}
                                                    alt={productDetailsA[productKey].altDescription}
                                                    className="img-fluid product-preview"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>


                <div className="fl-card-border container text-center  p-5">
                    <h2 style={{ marginTop: '40px' }} className="fl-title mt-0 py-5 gradient-text fl-title m-4">A Phased Blueprint for Digital Maturity with AVAP</h2>

                    <p className="fl-text fl-txt-container-s">Digital transformation is not a one-step process — it’s an architectural evolution. AVAP enables this journey across five strategic phases, each one delivering clear benefits to citizens (or end users) and organizations, while activating the right technologies at each stage:
                   DigitalTransformation
                   <img
                        src={dashboard}
                        className="img-fluid mt-4"
                        style={{ width: '70%', maxWidth: '800px', height: 'auto' }}
                    />
                    </p><br/>
                    
                </div>

                {/* Sección Built */} 
                {/*<section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="rightBC">
                                    <h3 className='fl-title'>Built for modern teams</h3>
                                    <p>AVAP Integration empowers both IT and business users with no-code/low-code tools and reusable virtual connectors for:
                                    </p>*/} 
                                    {/* Sección Bullets */}
                                   {/* <ul className="fl-bullets fl-text  .fl-txt-container-s " >
                                    <li className="fl-bullets">Cloud & SaaS platforms</li>
                                    <li className="fl-bullets">On-prem legacy systems</li>
                                    <li className="fl-bullets">Databases & messaging systems</li>
                                    <li className="fl-bullets">Internal and third-party APIs</li>
                                    </ul>
                                    <p>Break data silos and give teams the freedom to build connected workflows across any system.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>*/}

                {/*MASONRY 2 COLUMNAS, ICONO CENTRADO, FONDO GRIS, TITULO Y PÁRRAFO */}
                <div className="container">
                <div className="fl-title text-center mb-5">
                What Makes AVAP Different?
                    </div>
                    <Masonry
                    breakpointCols={breakpointColumnsObj}
                    className="masonry-grid"
                    columnClassName="masonry-column"
                    >
                    {items.map((item, idx) => (
                        <div key={idx} className="fl-card-s text-center grayBox">
                        <img src={item.icon} alt="Icon representing 0X" className="solutionsIcon" />
                        <p className="fl-subtitle-xs">{item.title}</p>
                        {item.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                        ))}
                        </div>
                    ))}
                    </Masonry>
                </div>

                {/* Sección Key Benefits */}   
               {/* <section className="container fl-z-index-2 position-relative mb-8">
                    <div className="row">
                        <div className="col  mb-5">
                            <div className="fl-title text-center mb-3">
                                Key Benefits
                            </div>
                        </div>
                    </div>
                    <div className="row ">
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                
                                <p className="fl-subtitle-xs">
                                Unify your data
                                </p>
                                <p className="fl-text">
                                Create a single source of truth by linking all your systems, regardless of format or source.

                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Accelerate delivery
                                </p>
                                <p className="fl-text">
                                Start faster with AI-assisted configuration, smart templates, and reusable integration assets.
                                    <br />&nbsp;
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Make integration intelligent
                                </p>
                                <p className="fl-text">
                                Predict bottlenecks, monitor flows, and auto-tune performance with AVAP’s Gen-AI engine.

                                </p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Protect every connection
                                </p>
                                <p className="fl-text">
                                Enforce policies across all connections with dynamic authentication, rate limiting, and encryption — built in.

                                </p>
                            </div>
                        </div>
                        
                        <div className="col-md-4">
                            <div className="fl-card grayGradient">
                                
                                <img
                                src={icn_vision}
                                alt="Icon representing 01."
                                className="mb-3 aboutIcon"
                                />
                                <p className="fl-subtitle-xs">
                                Measure and improve
                                </p>
                                <p className="fl-text">
                                Track integration KPIs in real time with built-in analytics and smart dashboards.

                                </p>
                            </div>
                        </div>

                    </div>
                </section>*/} 

                {/*Boton Contact Us*/}  
                <a className="glowBtn-dark " style={{zIndex: 2}} href="/contact" target='_blank'><span className="btnInner">   Contact Us  </span></a>


                {/* Sección built for secure */} 
                {/*<section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4">

                                <div className="blob"></div>
    

                                <div className="rightBC">
                                    <h3 className='fl-title'>Designed for your architecture</h3>
                                    <p>Whether you're operating in the cloud, on-prem, or in hybrid environments, AVAP Framework adapts seamlessly to your infrastructure and governance model.

                                    </p>

                                </div>
                            </div>
                        </div>
                    </div>
                </section>*/}

            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default PublicSector;
